export default __webpack_public_path__ + "static/media/Samosa.c4329df1.svg";